import { createReducer, on } from "@ngrx/store";
import {
  imaxxAppModuleEnabled,
  imaxxFeatureFlagEnabled,
  updateImaxxEnabled,
} from "./imaxx-eligible.actions";

export const featureKey = "imaxxEligible";

export interface ImaxxEligibleState {
  appModuleEnabled: boolean;
  featureFlagEnabled: boolean;
  isEnabled: boolean;
}

export const initialState: ImaxxEligibleState = {
  appModuleEnabled: false,
  featureFlagEnabled: false,
  isEnabled: false,
};

export const imaxxEligibleReducer = createReducer(
  initialState,
  on(imaxxAppModuleEnabled, (state, { isEnabled }) => ({
    ...state,
    appModuleEnabled: isEnabled,
  })),
  on(imaxxFeatureFlagEnabled, (state, { isEnabled }) => ({
    ...state,
    featureFlagEnabled: isEnabled,
  })),
  on(updateImaxxEnabled, (state, { isEnabled }) => ({ ...state, isEnabled }))
);
